import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import theme from './utils/theme';

// Add global styles for mobile optimization
const GlobalStyles = document.createElement('style');
GlobalStyles.textContent = `
  @media print {
    body {
      background: white !important;
      color: black !important;
    }
    
    * {
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
    }
  }

  @media (max-width: 600px) {
    html {
      font-size: 14px;
    }
  }

  * {
    -webkit-tap-highlight-color: transparent;
  }

  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overscroll-behavior-y: none;
  }
`;
document.head.appendChild(GlobalStyles);

// Add viewport meta tag for mobile optimization
const ViewportMeta = document.createElement('meta');
ViewportMeta.name = 'viewport';
ViewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
document.head.appendChild(ViewportMeta);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below.
serviceWorkerRegistration.register(); 